import React from 'react';
import { Field } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { createMultiFilterOptions } from './CustomExtendedDataField';
import FieldMultiSelect from '../FieldMultiSelect/FieldMultiSelect';
import { SecondaryButton } from '../Button/Button';
import Icons from '../Icons/Icons';

import css from './CustomExtendedDataField.module.css';
const InterestFieldArray = ({ fields }) => {
  const intl = useIntl();

  return (
    <>
      {fields.map((name, index) => (
        <div key={name} className={classNames(css.customField, css.addFields)}>
          <Field
            name={name}
            component="input"
            type="text"
            placeholder={intl.formatMessage({
              id: 'TalentFormCard.interest.placeholder',
            })}
          />
          <button className={css.delete} type="button" onClick={() => fields.remove(index)}>
            <Icons name="bin" />
          </button>
        </div>
      ))}

      <SecondaryButton className={css.addInterestBtn} type="button" onClick={() => fields.push('')}>
        {intl.formatMessage({ id: 'TalentFormCard.addInterest' })}
      </SecondaryButton>
    </>
  );
};

const RenderInterests = ({ name, formId, label, enumOptions }) => {
  return (
    <>
      <div className={classNames(css.customField, css.customSelectField)}>
        {/* Multi-Select Dropdown for pub_interest */}
        <Field
          component={FieldMultiSelect}
          isMulti={true}
          id={formId ? `${formId}.${name}` : name}
          name={name}
          label={label}
          options={createMultiFilterOptions(enumOptions)}
        />
      </div>
      {/* Dynamic Field Array for Additional Interests */}
      <FieldArray name="customInterests">
        {({ fields }) => <InterestFieldArray fields={fields} />}
      </FieldArray>
    </>
  );
};

export default RenderInterests;
